import { z } from 'zod'

import {
  isoDateSchema,
  nullableNumber,
  nullableString,
  serverItemSchema,
} from '../../utils/schema'

type OneShopBroadcast = z.infer<typeof oneshopBroadcastSchema>

const oneshopBroadcastSchema = serverItemSchema.extend({
  title: nullableString,
  type: nullableString,
  status: nullableString,
  date: isoDateSchema,
  queuedAt: isoDateSchema.nullable(),
  sentAt: isoDateSchema.nullable(),
  processCount: nullableNumber,
  errors: nullableString,
  smsCount: nullableNumber,
  emailCount: nullableNumber,
  smsCountSent: nullableNumber,
  emailCountSent: nullableNumber,
  lastMessageSentAt: isoDateSchema.nullable(),
  account: serverItemSchema
    .extend({
      companyName: nullableString,
    })
    .nullable(),
})

export type { OneShopBroadcast }

export { oneshopBroadcastSchema }
